import pages from "./pages.json";
import localizedPages from "./localized-pages.json";
import { languages, parseLanguagePath, languagePath } from "../i18n/routing";
const origin = "https://www.sharp-view.ca";

export function getMetadata(pathname) {
  const { language, pathname: normalized } = parseLanguagePath(pathname);
  const route = ["/pricing", "/features"].includes(normalized) ? "/" : normalized;
  const basePage = pages[route] || {
    title: "Page Not Found | Sharp View",
    description: "Explore Sharp View accounting ERP software and services.",
    robots: "noindex, follow",
  };
  const page = { ...basePage, ...(localizedPages[language]?.[route] || {}) };
  return {
    ...page,
    language,
    direction: language === "ar" ? "rtl" : "ltr",
    // Match the trailing slash used by static directory index redirects.
    canonical: `${origin}${languagePath(route, language)}`,
    alternates: pages[route] && !page.robots?.includes("noindex")
      ? [...languages.map((code) => ({ language: code, href: `${origin}${languagePath(route, code)}` })),
        { language: "x-default", href: `${origin}${languagePath(route, "en")}` }]
      : [],
    robots: page.robots || "index, follow",
    ogTitle: page.ogTitle || page.title,
    ogDescription: page.ogDescription || page.description,
  };
}

export const routes = Object.keys(pages);
